import get from 'lodash/get';
import queryString from 'query-string';

import { messengerReducerKey } from './reducer';

/** Returns the messenger state slice. */
export const extractFrom = state => state[messengerReducerKey];

/** Returns the entire messenger state */
export const getMessengerState = (state) => {
  return extractFrom(state);
};

/** Returns the messages in messenger state */
export const getMessengerMessages = (state) => {
  return extractFrom(state).messages;
};

/** Returns whether the messenger is currently open */
export const getMessengerIsOpen = () => {
  const { search } = window.location;
  const queryParams = queryString.parse(search);
  const openValue = get(queryParams, 'messenger', '');
  return openValue === 'open';
};
